import { Typography } from '@design-system/components/typography/typography';
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';
import * as styles from './SelectableButton.css';
export const SelectableButton = (
  p: PropsWithChildren<{
    minWidth?: number;
    isSelected: boolean;
    onClick: DetailedHTMLProps<
      HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >['onClick'];
  }>,
) => {
  const style: React.CSSProperties = {};
  if (p.minWidth) style.minWidth = `${p.minWidth}px`;
  return (
    <div
      onClick={p.onClick}
      className={p.isSelected ? styles.selectedWrapper : styles.wrapper}
      style={style}
    >
      <Typography variant="body" size="medium">
        {p.children}
      </Typography>
    </div>
  );
};
